import Vue from 'vue';
import Router from 'vue-router';

import SetPassword from './views/SetPassword.vue';
import ForgetPassword from './views/ForgetPassword.vue';
import Login from './views/Login.vue';
import Home from './views/Home.vue';
import About from './views/About.vue';
// Home Inspector Components
import HomeInspector from './views/home-inspector/Index.vue';
import HomeInspectorPageOne from './views/home-inspector/PageOne.vue';
import HomeInspectorPageTwo from './views/home-inspector/PageTwo.vue';
import HomeInspectorPageThree from './views/home-inspector/PageThree.vue';
import HomeInspectorPageFour from './views/home-inspector/PageFour.vue';
import HomeInspectorPageFive from './views/home-inspector/PageFive.vue';
import HomeInspectorPageSix from './views/home-inspector/PageSix.vue';
import HomeInspectorPageSeven from './views/home-inspector/PageSeven.vue';
import HomeInspectorRepresentation from './views/home-inspector/Representation.vue';
import HomeInspectorARDisclosure from './views/home-inspector/AR-SL-Disclosure.vue';
import HomeInspectorCADisclosure from './views/home-inspector/CA-SL-Disclosure.vue';
import HomeInspectorFLDisclosure from './views/home-inspector/FL-SL-Disclosure.vue';
import HomeInspectorKSDisclosure from './views/home-inspector/KS-SL-Disclosure.vue';
import HomeInspectorNDDisclosure from './views/home-inspector/ND-SL-Disclosure.vue';
import HomeInspectorWVDisclosure from './views/home-inspector/WV-SL-Disclosure.vue';
import HomeInspectorWYDisclosure from './views/home-inspector/WY-SL-Disclosure.vue';
import HomeInspectorNJDisclosure from './views/home-inspector/NJ-SL-Disclosure.vue';
import HomeInspectorNEDisclosure from './views/home-inspector/NE-SL-Disclosure.vue';
import HomeInspectorWADisclosure from './views/home-inspector/WA-SL-Disclosure.vue';
import HomeInspectorCTDisclosure from './views/home-inspector/CT-SL-Disclosure.vue';
import HomeInspectorMADisclosure from './views/home-inspector/MA-SL-Disclosure.vue';
import HomeInspectorOHDisclosure from './views/home-inspector/OH-SL-Disclosure.vue';
import HomeInspectorNYDisclosure from './views/home-inspector/NY-SL-Disclosure.vue';

import HomeInspectorARPolicyHolderNotice from './views/home-inspector/AR-PH-Notice.vue';
import HomeInspectorNDPolicyHolderNotice from './views/home-inspector/ND-PH-Notice.vue';
import HomeInspectorWVPolicyHolderNotice from './views/home-inspector/WV-PH-Notice.vue';
import HomeInspectorWYPolicyHolderNotice from './views/home-inspector/WY-PH-Notice.vue';
import HomeInspectorNJPolicyHolderNotice from './views/home-inspector/NJ-PH-Notice.vue';
import HomeInspectorOHPolicyHolderNotice from './views/home-inspector/OH-PH-Notice.vue';
import HomeInspectorRIPolicyHolderNotice from './views/home-inspector/RI-PH-Notice.vue';

import HomeInspectorFinal from './views/home-inspector/Final.vue';
import HomeInspectorPayment from './views/home-inspector/Payment.vue';

import Ipfs from './views/ipfs/Index.vue';
import IpfsPayment from './views/ipfs/Payment.vue';
import IpfsPayment30 from './views/ipfs/Payment-30.vue';
import CustomPayment from './views/ipfs/CustomPayment';
import CustomPayment30 from './views/ipfs/CustomPayment-30.vue';
import CustomPayment60 from './views/ipfs/CustomPayment-60.vue';
import CustomPayment60Amba from './views/ipfs/CustomPayment-60-Amba.vue';
import CustomPayment60Realshield from './views/ipfs/CustomPayment-60-Realshield.vue';
import CustomPaymentIBD from './views/ipfs/CustomPaymentIBD.vue';
import CustomPaymentIBD2 from './views/ipfs/CustomPaymentIBD2.vue';
import CustomPaymentSPMGA from './views/ipfs/CustomPayment-SPMGA.vue';
import CustomPaymentRWS from './views/ipfs/CustomPayment-RWS.vue';
import CustomPayment95 from './views/ipfs/CustomPayment-95.vue';
import CustomPayment150 from './views/ipfs/CustomPayment-150.vue';
import CustomPayment175 from './views/ipfs/CustomPayment-175.vue';

import CustomPaymentAccelerant from './views/ipfs/CustomPayment-Accelerant';
import CustomPaymentErmunro from './views/ipfs/CustomPayment-Ermunro';
import CustomPaymentAccelerantAX from './views/ipfs/CustomPayment-Accelerant-Ax';
import CustomPaymentAccelerant60 from './views/ipfs/CustomPayment-Accelerant-60.vue';
import CustomPaymentAccelerant60AX from './views/ipfs/CustomPayment-Accelerant-60-Ax.vue';
import CustomPaymentAccelerant95 from './views/ipfs/CustomPayment-Accelerant-95.vue';
import CustomPaymentAccelerant150 from './views/ipfs/CustomPayment-Accelerant-150.vue';
import CustomPaymentAccelerant175 from './views/ipfs/CustomPayment-Accelerant-175.vue';

import PaymentFinancingAccelerant from "./views/ipfs/PaymentFinancing-Accelerant";
import PaymentFinancingAccelerant95 from "./views/ipfs/PaymentFinancing-Accelerant-95";
import PaymentFinancingAccelerant150 from "./views/ipfs/PaymentFinancing-Accelerant-150";

// Individual Appraiser Components
import IndividualAppraiser from './views/individual-appraiser/Index.vue';
import IndividualAppraiserPageOne from './views/individual-appraiser/PageOne.vue';
import IndividualAppraiserPageTwo from './views/individual-appraiser/PageTwo.vue';
import IndividualAppraiserPageThree from './views/individual-appraiser/PageThree.vue';
import IndividualAppraiserPageFour from './views/individual-appraiser/PageFour.vue';
import IndividualAppraiserPageFive from './views/individual-appraiser/PageFive.vue';
import IndividualAppraiserPageSix from './views/individual-appraiser/PageSix.vue';
import IndividualAppraiserRepresentation from './views/individual-appraiser/Representation.vue';
import IndividualAppraiserRequestFinancing from './views/individual-appraiser/RequestFinancing.vue';

import IndividualAppraiserEmailSent from './views/individual-appraiser/EmailSent.vue';
import IndividualAppraiserStateSpecificPage from './views/individual-appraiser/StateSpecificPage.vue';
// Group Appraiser Components
import GroupAppraiser from './views/group-appraiser/Index.vue';
import GroupAppraiserPageOne from './views/group-appraiser/PageOne.vue';
import GroupAppraiserPageTwo from './views/group-appraiser/PageTwo.vue';
import GroupAppraiserPageThree from './views/group-appraiser/PageThree.vue';
import GroupAppraiserPageFour from './views/group-appraiser/PageFour.vue';
import GroupAppraiserRepresentation from './views/group-appraiser/Representation.vue';


// RX Application Components
import RXApplication from './views/rx-application/Index.vue';
import RXApplicationPageOne from './views/rx-application/PageOne.vue';
import RXApplicationPageTwo from './views/rx-application/PageTwo.vue';
import RXApplicationCAPageTwo from './views/rx-application/CAPageTwo.vue';
import RXApplicationPageThree from './views/rx-application/PageThree.vue';
import RXApplicationPageFour from './views/rx-application/PageFour.vue';
import RXApplicationPageFive from './views/rx-application/PageFive.vue';
import RXApplicationPageSix from './views/rx-application/PageSix.vue';
import RXApplicationPageSeven from './views/rx-application/PageSeven.vue';
import RXApplicationRepresentation from './views/rx-application/Representation.vue';
import RXApplicationStandardProgram from './views/rx-application/RXApplicationStandardProgram.vue';
import RXApplicationRequestFinancing from './views/rx-application/RequestFinancing.vue';
import RXApplicationWADisclosure from './views/rx-application/WA-SL-Disclosure.vue';
import RXApplicationPayment from './views/rx-application/Payment.vue';

// AX Application Components
import AXApplication from './views/ax-application/Index.vue';
import AXApplicationPageOne from './views/ax-application/PageOne.vue';
import AXApplicationPageTwo from './views/ax-application/PageTwo.vue';
import AXApplicationPageThree from './views/ax-application/PageThree.vue';
import AXApplicationPageFour from './views/ax-application/PageFour.vue';
import AXApplicationPageFive from './views/ax-application/PageFive.vue';
import AXApplicationPageSix from './views/ax-application/PageSix.vue';
import AXApplicationRepresentation from './views/ax-application/Representation.vue';
import AXApplicationPayment from './views/ax-application/Payment.vue';
import AXApplicationRequestFinancing from './views/ax-application/RequestFinancing.vue';
import AXApplicationEmailSent from './views/ax-application/EmailSent.vue';
import AXApplicationStateSpecificPage from './views/ax-application/StateSpecificPage.vue';
import AXApplicationWADisclosure from './views/ax-application/WA-SL-Disclosure.vue';
import AXApplicationMADisclosure from './views/ax-application/MA-SL-Disclosure.vue';
import AXApplicationCTDisclosure from './views/ax-application/CT-SL-Disclosure.vue';
import AXApplicationNYNoticeOfExcess from './views/ax-application/NY-Notice-Of-Excess.vue';


// Standard Application Components
import StandardApplication from './views/standard-application/Index.vue';
import StandardApplicationPageOne from './views/standard-application/PageOne.vue';
import StandardApplicationPageTwo from './views/standard-application/PageTwo.vue';
import StandardApplicationPageThree from './views/standard-application/PageThree.vue';
import StandardApplicationPageFour from './views/standard-application/PageFour.vue';
import StandardApplicationPageFive from './views/standard-application/PageFive.vue';
import StandardApplicationPageSix from './views/standard-application/PageSix.vue';
import StandardApplicationPageSeven from './views/standard-application/PageSeven.vue';
import StandardApplicationPageEight from './views/standard-application/PageEight.vue';
import StandardApplicationRepresentation from './views/standard-application/Representation.vue';
import StandardApplicationMADisclosure from './views/standard-application/MA-SL-Disclosure.vue';
import StandardApplicationCTDisclosure from './views/standard-application/CT-SL-Disclosure.vue';
import StandardApplicationNYNoticeOfExcess from './views/standard-application/NY-Notice-Of-Excess.vue';

import ContactUs from './views/ContactUs.vue';
import PaymentFinancing from "./views/ipfs/PaymentFinancing";
import PaymentFinancing95 from "./views/ipfs/PaymentFinancing-95";
import PaymentFinancing150 from "./views/ipfs/PaymentFinancing-150";
import CustomPaymentInspector from "@/views/ipfs/CustomPaymentInspector";

// PI Application Components
import PIApplication from './views/pi-application/Index.vue';
import PIApplicationPageOne from './views/pi-application/PageOne.vue';
import PIApplicationPageTwo from './views/pi-application/PageTwo.vue';
import PIApplicationRepresentation from './views/pi-application/Representation.vue';

// Quick Quote Application Components
import QuickQuote from './views/quick-quote/Index.vue';
import QuickQuotePageOne from './views/quick-quote/PageOne.vue';
import QuickQuoteRepresentation from './views/quick-quote/Representation.vue';

import SipApplication from './views/sip-application/Index.vue';
import SipApplicationPageOne from './views/sip-application/PageOne.vue';
import SipApplicationPageTwo from './views/sip-application/PageTwo.vue';
import SipApplicationPageThree from './views/sip-application/PageThree.vue';
import SipApplicationPageFour from './views/sip-application/PageFour.vue';
import SipApplicationRepresentation from './views/sip-application/Representation.vue';

import PpiApplication from './views/ppi-application/Index.vue';
import PpiApplicationPageOne from './views/ppi-application/PageOne.vue';
import PpiApplicationPageTwo from './views/ppi-application/PageTwo.vue';
import PpiApplicationPageThree from './views/ppi-application/PageThree.vue';
import PpiApplicationPageFour from './views/ppi-application/PageFour.vue';
import PpiApplicationPageFive from './views/ppi-application/PageFive.vue';
import PpiApplicationRepresentation from './views/ppi-application/Representation.vue';

import RCApplication from './views/rc-application/Index.vue';
import RCApplicationPageOne from './views/rc-application/PageOne.vue';
import RCApplicationPageTwo from './views/rc-application/PageTwo.vue';
import RCApplicationPageThree from './views/rc-application/PageThree.vue';
import RCApplicationPageFour from './views/rc-application/PageFour.vue';
import RCApplicationPageFive from './views/rc-application/PageFive.vue';
import RCApplicationPageSix from './views/rc-application/PageSix.vue';
import RCApplicationRepresentation from './views/rc-application/Representation.vue';

// Insurance-Agent Application Components
import InsuranceAgentApplication from './views/insurance-agent-application/Index.vue';
import InsuranceAgentApplicationPageOne from './views/insurance-agent-application/PageOne.vue';
import InsuranceAgentApplicationPageTwo from './views/insurance-agent-application/PageTwo.vue';
import InsuranceAgentApplicationPageThree from './views/insurance-agent-application/PageThree.vue';
import InsuranceAgentApplicationPageFour from './views/insurance-agent-application/PageFour.vue';
import InsuranceAgentApplicationPageFive from './views/insurance-agent-application/PageFive.vue';
import InsuranceAgentApplicationPageSix from './views/insurance-agent-application/PageSix.vue';
import InsuranceAgentApplicationRepresentation from './views/insurance-agent-application/Representation.vue';


// MGA Application Components
import MgaApplication from './views/mga-application/Index.vue';
import MgaApplicationPageOne from './views/mga-application/PageOne.vue';
import MgaApplicationPageTwo from './views/mga-application/PageTwo.vue';
import MgaApplicationPageThree from './views/mga-application/PageThree.vue';
import MgaApplicationPageFour from './views/mga-application/PageFour.vue';
import MgaApplicationPageFive from './views/mga-application/PageFive.vue';
import MgaApplicationPageSix from './views/mga-application/PageSix.vue';
import MgaApplicationPageSeven from './views/mga-application/PageSeven.vue';
import MgaApplicationRepresentation from './views/mga-application/Representation.vue';
import CustomPaymentRISKPRO from "@/views/ipfs/CustomPayment-RISKPRO.vue";


Vue.use(Router);

// Dynamically determine base path based on the hostname
const baseRoute = window.location.hostname === 'www.liabilityinsuranceapps.com' ? '' : '/portal';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: '404',
      component: Login,
    },
    {
      path: `${baseRoute}/set-password`,
      name: 'setPassword',
      component: SetPassword,
    },
    {
      path: `${baseRoute}/forget-password`,
      name: 'forgetPassword',
      component: ForgetPassword,
    },
    { path: `${baseRoute}/login-mercer`, redirect: `${baseRoute}/login-amba` },
    {
      path: `${baseRoute}/login`,
      alias: [`${baseRoute}/login-amba`,`${baseRoute}/login-realshield`,`${baseRoute}/login-ibdpro`],
      name: 'login',
      component: Login,
    },
    {
      path: `${baseRoute}/home`,
      name: 'home',
      component: Home,
    },
    { path: `${baseRoute}/about-mercer`, redirect: `${baseRoute}/about-amba` },
    {
      path: `${baseRoute}/about`,
      alias: [`${baseRoute}/about-amba`, `${baseRoute}/about-ibdpro`],
      name: 'about',
      component: About,
    },
    {
      path: `${baseRoute}/about-ibdpro`,
      name: 'about-ibdpro',
      component: About,
    },
    {
      path: `${baseRoute}/about-amba`,
      name: 'about-amba',
      component: About,
    },
    {
      path: `${baseRoute}/about-realshield`,
      name: 'about-realshield',
      component: About,
    },
    {
      path: `${baseRoute}/contact`,
      name: 'contact',
      component: ContactUs,
    },
    {
      path: `${baseRoute}/ipfs`,
      component: Ipfs,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/ipfs/payment`,
        },
        {
          path: 'payment',
          name: 'ipfs-payment',
          component: IpfsPayment,
        },
        {
          path: 'payment-30',
          name: 'ipfs-payment-30',
          component: IpfsPayment30,
        },
        {
          path: 'custom-payment',
          name: 'custom-payment',
          component: CustomPayment,
        },
        {
          path: 'custom-payment-spmga',
          name: 'custom-payment-spmga',
          component: CustomPaymentSPMGA,
        },
        {
          path: 'custom-payment-rws',
          name: 'custom-payment-rws',
          component: CustomPaymentRWS,
        },
        {
          path: 'custom-payment-riskpro',
          name: 'custom-payment-riskpro',
          component: CustomPaymentRISKPRO,
        },
        {
          path: 'custom-payment-ibdpro',
          name: 'custom-payment-ibdpro',
          component: CustomPaymentIBD,
        },
        {
          path: 'custom-payment-ibdpro2',
          name: 'custom-payment-ibdpro2',
          component: CustomPaymentIBD2,
        },
        {
          path: 'custom-payment-60',
          name: 'custom-payment-60',
          component: CustomPayment60,
        },
        {
          path: 'custom-payment-30',
          name: 'custom-payment-30',
          component: CustomPayment30,
        },
        {
          path: 'custom-payment-60-amba',
          name: 'custom-payment-60-amba',
          component: CustomPayment60Amba,
        },
        {
          path: 'custom-payment-60-realshield',
          name: 'custom-payment-60-realshield',
          component: CustomPayment60Realshield,
        },
        {
          path: 'custom-payment-95',
          name: 'custom-payment-95',
          component: CustomPayment95,
        },
        {
          path: 'custom-payment-150',
          name: 'custom-payment-150',
          component: CustomPayment150,
        },
        {
          path: 'custom-payment-175',
          name: 'custom-payment-175',
          component: CustomPayment175,
        },
        {
          path: 'custom-payment-accelerant',
          name: 'custom-payment-accelerant',
          component: CustomPaymentAccelerant,
        },
        {
          path: 'custom-payment-ermunro',
          name: 'custom-payment-ermunro',
          component: CustomPaymentErmunro,
        },
        {
          path: 'custom-payment-accelerant-ax',
          name: 'custom-payment-accelerant-ax',
          component: CustomPaymentAccelerantAX,
        },
        {
          path: 'custom-payment-60-accelerant',
          name: 'custom-payment-60-accelerant',
          component: CustomPaymentAccelerant60,
        },
        {
          path: 'custom-payment-60-accelerant-ax',
          name: 'custom-payment-60-accelerant-ax',
          component: CustomPaymentAccelerant60AX,
        },
        {
          path: 'custom-payment-95-accelerant',
          name: 'custom-payment-95-accelerant',
          component: CustomPaymentAccelerant95,
        },
        {
          path: 'custom-payment-150-accelerant',
          name: 'custom-payment-150-accelerant',
          component: CustomPaymentAccelerant150,
        },
        {
          path: 'custom-payment-175-accelerant',
          name: 'custom-payment-175-accelerant',
          component: CustomPaymentAccelerant175,
        },
        {
          path: 'payment-financing',
          name: 'payment-financing',
          component: PaymentFinancing,
        },
        {
          path: 'payment-financing-95',
          name: 'payment-financing-95',
          component: PaymentFinancing95,
        },
        {
          path: 'payment-financing-150',
          name: 'payment-financing-150',
          component: PaymentFinancing150,
        },
        {
          path: 'payment-financing-accelerant',
          name: 'payment-financing-accelerant',
          component: PaymentFinancingAccelerant,
        },
        {
          path: 'payment-financing-95-accelerant',
          name: 'payment-financing-95-accelerant',
          component: PaymentFinancingAccelerant95,
        },
        {
          path: 'payment-financing-150-accelerant',
          name: 'payment-financing-150-accelerant',
          component: PaymentFinancingAccelerant150,
        },
        {
          path: 'custom-payment-inspectors',
          name: 'custom-payment-inspectors',
          component: CustomPaymentInspector,
        },
      ],
    },
    // Home Inspector
    {
      path: `${baseRoute}/home-inspector`,
      alias: [`${baseRoute}/home-inspector-ibd`, `/RISKPRO/home-inspector`, `/riskpro/home-inspector`, `${baseRoute}/home-inspector-rws`, `${baseRoute}/home-inspector-spmga`, `${baseRoute}/home-inspector-NEW`],
      component: HomeInspector,
      children: [
        {
          path: '',
          redirect: 'page-1',
        },
        { path: `${baseRoute}/home-inspector-rws`, redirect: `${baseRoute}/home-inspector/page-1` },
        { path: `${baseRoute}/home-inspector-rws/page-1`, redirect: `${baseRoute}/home-inspector/page-1` },
        {
          path: 'page-1',
          name: 'home-inspector-1',
          component: HomeInspectorPageOne,
        },
        {
          path: 'page-2',
          name: 'home-inspector-2',
          component: HomeInspectorPageTwo,
        },
        {
          path: 'page-3',
          name: 'home-inspector-3',
          component: HomeInspectorPageThree,
        },
        {
          path: 'page-4',
          name: 'home-inspector-4',
          component: HomeInspectorPageFour,
        },
        {
          path: 'page-5',
          name: 'home-inspector-5',
          component: HomeInspectorPageFive,
        },
        {
          path: 'page-6',
          name: 'home-inspector-6',
          component: HomeInspectorPageSix,
        },
        {
          path: 'page-7',
          name: 'home-inspector-7',
          component: HomeInspectorPageSeven,
        },

        {
          path: 'final',
          name: 'home-inspector-final',
          component: HomeInspectorFinal,
        },
        {
          path: 'payment',
          name: 'home-inspector-payment',
          component: HomeInspectorPayment,
        },

        {
          path: 'AR-SL-Disclosure',
          name: 'home-inspector-ar-sl-disclosure',
          component: HomeInspectorARDisclosure,
        },
        {
          path: 'ND-SL-Disclosure',
          name: 'home-inspector-nd-sl-disclosure',
          component: HomeInspectorNDDisclosure,
        },
        {
          path: 'NJ-SL-Disclosure',
          name: 'home-inspector-nj-sl-disclosure',
          component: HomeInspectorNJDisclosure,
        },
        {
          path: 'OH-SL-Disclosure',
          name: 'home-inspector-oh-sl-disclosure',
          component: HomeInspectorOHDisclosure,
        },
        {
          path: 'WV-SL-Disclosure',
          name: 'home-inspector-wv-sl-disclosure',
          component: HomeInspectorWVDisclosure,
        },
        {
          path: 'WY-SL-Disclosure',
          name: 'home-inspector-wy-sl-disclosure',
          component: HomeInspectorWYDisclosure,
        },
        {
          path: 'CA-SL-Disclosure',
          name: 'home-inspector-ca-sl-disclosure',
          component: HomeInspectorCADisclosure,
        },
        {
          path: 'FL-SL-Disclosure',
          name: 'home-inspector-fl-sl-disclosure',
          component: HomeInspectorFLDisclosure,
        },
        {
          path: 'KS-SL-Disclosure',
          name: 'home-inspector-ks-sl-disclosure',
          component: HomeInspectorKSDisclosure,
        },
        {
          path: 'NE-SL-Disclosure',
          name: 'home-inspector-ne-sl-disclosure',
          component: HomeInspectorNEDisclosure,
        },
        {
          path: 'WA-SL-Disclosure',
          name: 'home-inspector-wa-sl-disclosure',
          component: HomeInspectorWADisclosure,
        },
        {
          path: 'CT-SL-Disclosure',
          name: 'home-inspector-ct-sl-disclosure',
          component: HomeInspectorCTDisclosure,
        },
        {
          path: 'MA-SL-Disclosure',
          name: 'home-inspector-ma-sl-disclosure',
          component: HomeInspectorMADisclosure,
        },
        {
          path: 'NY-SL-Disclosure',
          name: 'home-inspector-ny-sl-disclosure',
          component: HomeInspectorNYDisclosure,
        },

        {
          path: 'AR-Policy-Holder-Notice',
          name: 'home-inspector-ar-policy-holder-notice',
          component: HomeInspectorARPolicyHolderNotice,
        },
        {
          path: 'ND-Policy-Holder-Notice',
          name: 'home-inspector-nd-policy-holder-notice',
          component: HomeInspectorNDPolicyHolderNotice,
        },
        {
          path: 'NJ-Policy-Holder-Notice',
          name: 'home-inspector-nj-policy-holder-notice',
          component: HomeInspectorNJPolicyHolderNotice,
        },
        {
          path: 'OH-Policy-Holder-Notice',
          name: 'home-inspector-oh-policy-holder-notice',
          component: HomeInspectorOHPolicyHolderNotice,
        },
        {
          path: 'RI-Policy-Holder-Notice',
          name: 'home-inspector-ri-policy-holder-notice',
          component: HomeInspectorRIPolicyHolderNotice,
        },
        {
          path: 'WV-Policy-Holder-Notice',
          name: 'home-inspector-wv-policy-holder-notice',
          component: HomeInspectorWVPolicyHolderNotice,
        },
        {
          path: 'WY-Policy-Holder-Notice',
          name: 'home-inspector-wy-policy-holder-notice',
          component: HomeInspectorWYPolicyHolderNotice,
        },

        {
          path: 'representation',
          name: 'home-inspector-representation',
          component: HomeInspectorRepresentation,
        },
      ],
    },
    {
      path: `${baseRoute}/individual-appraiser`,
      component: IndividualAppraiser,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/individual-appraiser/page-1`,
        },
        {
          path: 'page-1',
          name: 'individual-appraiser-1',
          component: IndividualAppraiserPageOne,
          redirect: `${baseRoute}/ax-application/page-1`,
        },
        {
          path: 'page-2',
          name: 'individual-appraiser-2',
          component: IndividualAppraiserPageTwo,
        },
        {
          path: 'page-3',
          name: 'individual-appraiser-3',
          component: IndividualAppraiserPageThree,
        },
        {
          path: 'page-4',
          name: 'individual-appraiser-4',
          component: IndividualAppraiserPageFour,
        },
        {
          path: 'page-5',
          name: 'individual-appraiser-5',
          component: IndividualAppraiserPageFive,
        },
        {
          path: 'page-6',
          name: 'individual-appraiser-6',
          component: IndividualAppraiserPageSix,
        },
        {
          path: 'representation',
          name: 'individual-appraiser-representation',
          component: IndividualAppraiserRepresentation,
        },
        {
          path: 'request-financing/:id',
          name: 'individual-appraiser-request-financing',
          component: IndividualAppraiserRequestFinancing,
        },
        {
          path: 'email-sent',
          name: 'individual-appraiser-email-sent',
          component: IndividualAppraiserEmailSent,
        },
        {
          path: 'extra-page',
          name: 'individual-appraiser-extra-page',
          component: IndividualAppraiserStateSpecificPage,
        },
      ],
    },
    { path: `${baseRoute}/rx-application-mercer`, redirect: `${baseRoute}/rx-application-amba/page-1` },
    { path: `${baseRoute}/rx-application-amba`, redirect: `${baseRoute}/rx-application-amba/page-1` },
    { path: `${baseRoute}/rx-application-realshield`, redirect: `${baseRoute}/rx-application-realshield/page-1` },
    { path: `${baseRoute}/rx-application-mercer/page-1`, redirect: `${baseRoute}/rx-application-amba/page-1` },
    {
      path: `${baseRoute}/rx-application`,
      alias: [`${baseRoute}/rx-application-amba`,`${baseRoute}/rx-application-realshield`],
      component: RXApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/rx-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'rx-application-1',
          component: RXApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'rx-application-2',
          component: RXApplicationPageTwo,
        },
        {
          path: 'ca-page-2',
          name: 'rx-application-ca-2',
          component: RXApplicationCAPageTwo,
        },
        {
          path: 'page-3',
          name: 'rx-application-3',
          component: RXApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'rx-application-4',
          component: RXApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'rx-application-5',
          component: RXApplicationPageFive,
        },
        {
          path: 'page-6',
          name: 'rx-application-6',
          component: RXApplicationPageSix,
        },
        {
          path: 'page-7',
          name: 'rx-application-7',
          component: RXApplicationPageSeven,
        },
        {
          path: 'representation',
          name: 'rx-application-representation',
          component: RXApplicationRepresentation,
        },
        {
          path: 'payment',
          name: 'rx-application-payment',
          component: RXApplicationPayment,
        },
        {
          path: 'standard-program-page',
          name: 'rx-application-standard-program',
          component: RXApplicationStandardProgram,
        },
        {
          path: 'request-financing/:id',
          name: 'rx-application-request-financing',
          component: RXApplicationRequestFinancing,
        },
        {
          path: 'WA-SL-Disclosure',
          name: 'rx-application-wa-sl-disclosure',
          component: RXApplicationWADisclosure,
        },
      ],
    },
    { path: `${baseRoute}/ax-application-mercer`, redirect: `${baseRoute}/ax-application-amba/page-1` },
    { path: `${baseRoute}/ax-application-mercer/page-1`, redirect: `${baseRoute}/ax-application-amba/page-1` },
    { path: `${baseRoute}/ax-application-amba`, redirect: `${baseRoute}/ax-application-amba/page-1` },
    { path: `${baseRoute}/ax-application-realshield`, redirect: `${baseRoute}/ax-application-realshield/page-1` },
    {
      path: `${baseRoute}/ax-application`,
      alias: [`${baseRoute}/ax-application-amba`, `${baseRoute}/ax-application-realshield`],
      component: AXApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/ax-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'ax-application-1',
          component: AXApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'ax-application-2',
          component: AXApplicationPageTwo,
        },
        {
          path: 'page-3',
          name: 'ax-application-3',
          component: AXApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'ax-application-4',
          component: AXApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'ax-application-5',
          component: AXApplicationPageFive,
        },
        {
          path: 'page-6',
          name: 'ax-application-6',
          component: AXApplicationPageSix,
        },
        {
          path: 'representation',
          name: 'ax-application-representation',
          component: AXApplicationRepresentation,
        },
        {
          path: 'payment',
          name: 'ax-application-payment',
          component: AXApplicationPayment,
        },
        {
          path: 'request-financing/:id',
          name: 'ax-application-request-financing',
          component: AXApplicationRequestFinancing,
        },
        {
          path: 'email-sent',
          name: 'ax-application-email-sent',
          component: AXApplicationEmailSent,
        },
        {
          path: 'extra-page',
          name: 'ax-application-extra-page',
          component: AXApplicationStateSpecificPage,
        },
        {
          path: 'WA-SL-Disclosure',
          name: 'ax-application-wa-sl-disclosure',
          component: AXApplicationWADisclosure,
        },
        {
          path: 'MA-SL-Disclosure',
          name: 'ax-application-ma-sl-disclosure',
          component: AXApplicationMADisclosure,
        },
        {
          path: 'CT-SL-Disclosure',
          name: 'ax-application-ct-sl-disclosure',
          component: AXApplicationCTDisclosure,
        },
        {
          path: 'NY-Notice-Of-Excess',
          name: 'ax-application-ny-notice-of-excess',
          component: AXApplicationNYNoticeOfExcess,
        },
      ],
    },
    {
      path: `${baseRoute}/group-appraiser`,
      component: GroupAppraiser,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/group-appraiser/page-1`,
        },
        {
          path: 'page-1',
          name: 'group-appraiser-1',
          component: GroupAppraiserPageOne,
        },
        {
          path: 'page-2',
          name: 'group-appraiser-2',
          component: GroupAppraiserPageTwo,
        },
        {
          path: 'page-3',
          name: 'group-appraiser-3',
          component: GroupAppraiserPageThree,
        },
        {
          path: 'page-4',
          name: 'group-appraiser-4',
          component: GroupAppraiserPageFour,
        },
        {
          path: 'representation',
          name: 'group-appraiser-representation',
          component: GroupAppraiserRepresentation,
        },
      ],
    },
    { path: `${baseRoute}/standard-application-mercer`, redirect: `${baseRoute}/standard-application-amba/page-1` },
    { path: `${baseRoute}/standard-application-amba`, redirect: `${baseRoute}/standard-application-amba/page-1` },
    { path: `${baseRoute}/standard-application-realshield`, redirect: `${baseRoute}/standard-application-realshield/page-1` },
    { path: `${baseRoute}/standard-application-mercer/page-1`, redirect: `${baseRoute}/standard-application-amba/page-1` },
    {
      path: `${baseRoute}/standard-application`,
      alias: [`${baseRoute}/standard-application-amba`,`${baseRoute}/standard-application-realshield`],
      component: StandardApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/standard-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'standard-application-1',
          component: StandardApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'standard-application-2',
          component: StandardApplicationPageTwo,
        },
        {
          path: 'page-3',
          name: 'standard-application-3',
          component: StandardApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'standard-application-4',
          component: StandardApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'standard-application-5',
          component: StandardApplicationPageFive,
        },
        {
          path: 'page-6',
          name: 'standard-application-6',
          component: StandardApplicationPageSix,
        },
        {
          path: 'page-7',
          name: 'standard-application-7',
          component: StandardApplicationPageSeven,
        },
        {
          path: 'page-8',
          name: 'standard-application-8',
          component: StandardApplicationPageEight,
        },
        {
          path: 'representation',
          name: 'standard-application-representation',
          component: StandardApplicationRepresentation,
        },
        {
          path: 'MA-SL-Disclosure',
          name: 'standard-application-ma-sl-disclosure',
          component: StandardApplicationMADisclosure,
        },
        {
          path: 'CT-SL-Disclosure',
          name: 'standard-application-ct-sl-disclosure',
          component: StandardApplicationCTDisclosure,
        },
        {
          path: 'NY-Notice-Of-Excess',
          name: 'standard-application-ny-notice-of-excess',
          component: StandardApplicationNYNoticeOfExcess,
        },
      ],
    },
    {
      path: `${baseRoute}/pi-application`,
      component: PIApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/pi-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'pi-application-1',
          component: PIApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'pi-application-2',
          component: PIApplicationPageTwo,
        },
        {
          path: 'representation',
          name: 'pi-application-representation',
          component: PIApplicationRepresentation,
        },
      ],
    },

    {
      path: `${baseRoute}/quick-quote`,
      alias: [`${baseRoute}/quick-quote-spmga`],
      component: QuickQuote,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/quick-quote/page-1`,
        },
        {
          path: 'page-1',
          name: 'quick-quote-1',
          component: QuickQuotePageOne,
        },
        {
          path: 'representation',
          name: 'quick-quote-representation',
          component: QuickQuoteRepresentation,
        },
      ],
    },
    { path: `${baseRoute}/sip-application-mercer`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    { path: `${baseRoute}/sip-application-amba`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    { path: `${baseRoute}/sip-application-realshield`, redirect: `${baseRoute}/ppi-application-realshield/page-1` },
    { path: `${baseRoute}/sip-application-mercer/page-1`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    {
      path: `${baseRoute}/sip-application`,
      alias: [`${baseRoute}/sip-application-amba`, `${baseRoute}/sip-application-realshield`],
      component: SipApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/ppi-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'sip-application-1',
          redirect: `${baseRoute}/ppi-application/page-1`,
        },
        {
          path: 'page-2',
          name: 'sip-application-2',
          redirect: `${baseRoute}/ppi-application/page-2`,
        },
        {
          path: 'page-3',
          name: 'sip-application-3',
          redirect: `${baseRoute}/ppi-application/page-3`,
        },
        {
          path: 'page-4',
          name: 'sip-application-4',
          redirect: `${baseRoute}/ppi-application/page-4`,
        },
        {
          path: 'representation',
          name: 'sip-application-representation',
          redirect: `${baseRoute}/ppi-application/ppi-application-representation`,
        },
      ],
    },
    { path: `${baseRoute}/ppi-application-mercer`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    { path: `${baseRoute}/ppi-application-amba`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    { path: `${baseRoute}/ppi-application-realshield`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    { path: `${baseRoute}/ppi-application-mercer/page-1`, redirect: `${baseRoute}/ppi-application-amba/page-1` },
    {
      path: `${baseRoute}/ppi-application`,
      alias: [`${baseRoute}/ppi-application-amba`, `${baseRoute}/ppi-application-realshield`,  `/ERMUNRO/ppi-application`, `/ermunro/ppi-application`],
      component: PpiApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/ppi-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'ppi-application-1',
          component: PpiApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'ppi-application-2',
          component: PpiApplicationPageTwo,
        },
        {
          path: 'page-3',
          name: 'ppi-application-3',
          component: PpiApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'ppi-application-4',
          component: PpiApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'ppi-application-5',
          component: PpiApplicationPageFive,
        },
        {
          path: 'representation',
          name: 'ppi-application-representation',
          component: PpiApplicationRepresentation,
        },
      ],
    },
    { path: `${baseRoute}/rc-application-mercer`, redirect: `${baseRoute}/rc-application-amba/page-1` },
    { path: `${baseRoute}/rc-application-amba`, redirect: `${baseRoute}/rc-application-amba/page-1` },
    { path: `${baseRoute}/rc-application-realshield`, redirect: `${baseRoute}/rc-application-realshield/page-1` },
    { path: `${baseRoute}/rc-application-mercer/page-1`, redirect: `${baseRoute}/rc-application-amba/page-1` },
    {
      path: `${baseRoute}/rc-application`,
      alias: [`${baseRoute}/rc-application-amba`, `${baseRoute}/rc-application-realshield`],
      component: RCApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/rc-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'rc-application-1',
          component: RCApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'rc-application-2',
          component: RCApplicationPageTwo,
        },
        {
          path: 'page-3',
          name: 'rc-application-3',
          component: RCApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'rc-application-4',
          component: RCApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'rc-application-5',
          component: RCApplicationPageFive,
        },
        {
          path: 'page-6',
          name: 'rc-application-6',
          component: RCApplicationPageSix,
        },
        {
          path: 'representation',
          name: 'rc-application-representation',
          component: RCApplicationRepresentation,
        },
      ],
    },
    {
      path: `${baseRoute}/ibdpro-insurance-agent-application`,
      alias: [`${baseRoute}/ibdpro-insurance-agent-application-amba`,`${baseRoute}/ibdpro-insurance-agent-application-realshield`],
      component: InsuranceAgentApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/ibdpro-insurance-agent-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'ibdpro-insurance-agent-application-1',
          component: InsuranceAgentApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'ibdpro-insurance-agent-application-2',
          component: InsuranceAgentApplicationPageTwo,
        },
        {
          path: 'page-3',
          name: 'ibdpro-insurance-agent-application-3',
          component: InsuranceAgentApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'ibdpro-insurance-agent-application-4',
          component: InsuranceAgentApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'ibdpro-insurance-agent-application-5',
          component: InsuranceAgentApplicationPageFive,
        },
        {
          path: 'page-6',
          name: 'ibdpro-insurance-agent-application-6',
          component: InsuranceAgentApplicationPageSix,
        },
        {
          path: 'representation',
          name: 'ibdpro-insurance-agent-application-representation',
          component: InsuranceAgentApplicationRepresentation,
        },
      ],
    },
    {
      path: `${baseRoute}/ibdpro-mga-application`,
      alias: [`${baseRoute}/ibdpro-mga-application-amba`,`${baseRoute}/ibdpro-mga-application-realshield`],
      component: MgaApplication,
      children: [
        {
          path: '',
          redirect: `${baseRoute}/ibdpro-mga-application/page-1`,
        },
        {
          path: 'page-1',
          name: 'ibdpro-mga-application-1',
          component: MgaApplicationPageOne,
        },
        {
          path: 'page-2',
          name: 'ibdpro-mga-application-2',
          component: MgaApplicationPageTwo,
        },
        {
          path: 'page-3',
          name: 'ibdpro-mga-application-3',
          component: MgaApplicationPageThree,
        },
        {
          path: 'page-4',
          name: 'ibdpro-mga-application-4',
          component: MgaApplicationPageFour,
        },
        {
          path: 'page-5',
          name: 'ibdpro-mga-application-5',
          component: MgaApplicationPageFive,
        },
        {
          path: 'page-6',
          name: 'ibdpro-mga-application-6',
          component: MgaApplicationPageSix,
        },
        {
          path: 'page-6',
          name: 'ibdpro-mga-application-7',
          component: MgaApplicationPageSeven,
        },
        {
          path: 'representation',
          name: 'ibdpro-mga-application-representation',
          component: MgaApplicationRepresentation,
        },
      ],
    },
  ],
});

// ✅ WhatConverts re-init on route change
router.afterEach(() => {
  setTimeout(() => {
    window.gqnttmcumqahpthdocaw_150864 = false;
    window.nlalneaklrnkdcxeybga_150864 = false;
    window.aokdfgwtkgrrgfejilyt_150864 = false;

    if (window.$wc_leads) {
      window.$wc_leads.doc.url = JSON.parse(JSON.stringify(document.URL));
      window.$wc_leads.doc.search = JSON.parse(JSON.stringify(location.search));
      window.$wc_leads.doc.hash = JSON.parse(JSON.stringify(location.hash));
    }

    const existingScript = document.querySelector(
        'script[src="https://s.ksrndkehqnwntyxlhgto.com/150864.js"]'
    );
    if (existingScript) existingScript.remove();

    const script = document.createElement('script');
    script.src = 'https://s.ksrndkehqnwntyxlhgto.com/150864.js';
    document.head.appendChild(script);
  }, 500);
});

export default router;